


















/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export default Vue.extend({
  name: 'StandardFilterInput',

  props: {
    value: {
      type: [String, Number, Object, Array],
      default: '',
    },
    maxlength: {
      type: String,
      required: false,
      default: null,
    },
    placeholder: {
      type: String,
      required: true,
    },
    isFocused: {
      type: Boolean,
      default: false,
    },
    isEmphasized: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    internalValue: {
      get(): String | Number {
        return this.value
      },
      set(value: any): any {
        this.$emit('input', value)
      },
    },
  },

  watch: {
    isFocused: {
      handler(newValue) {
        if (this.$refs.inputRef !== undefined && newValue) {
          // @ts-ignore
          this.$refs.inputRef.focus()
        }
      },
    },
  },

  mounted() {
    if (this.isFocused) {
      // @ts-ignore
      this.$refs.inputRef.focus()
    }
  },

  methods: {
    submit() {
      this.$emit('blur')
      this.$emit('input-submitted', this.internalValue)
    },
  },
})
